import React, { useState, useEffect, useRef } from "react";
import { useMediaQuery } from "@mui/material";
import {
  Card,
  Button,
  OtpContainer,
  OtpInputContainer,
  ResendOtpLink,
  SuccessMessage,
  Label,
  InputField,
  ErrorText,
  Select,
  PayButton,
  LoginButton,
} from "../Dialog/PaymentDialogStyles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTheme } from "@mui/material/styles";
import { open_api_with_cookies } from "../../Utils/network";
import { PhoneInput } from "react-international-phone";
import "react-phone-input-2/lib/style.css";
import {
  fetchCountryCode,
  validatePhoneNumber,
  validateEmail,
  handleOTPChange,
  handleKeyDown,
  handlePhoneNumberChange,
  handleEmailChange,
  requestOTP,
  validateOTP,
  addAlert,
  removeAlert,
  fetchProfileTypes,
  checkUserInfoExists,
  fetchUserDetails,
  validateGoogleLoginWithToken,
} from "../Dialog/helper";
import useAuth from "../Hook/useAuth";
import { GoogleLogin } from "@react-oauth/google";
import CustomAlert from "../AlertDialog/CustomAlert";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "../Dialog/LoadingOverlay";
import UserProfileForm from "./UserProfileForm";
import googleLoginIcon from "../../Assets/login/googleLogin.svg";
import { useGoogleLogin } from "@react-oauth/google";
import { getCountryCode } from "../../Utils/network";
import "react-international-phone/style.css";
import styled from "styled-components";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

const CustomPhoneInput = styled(PhoneInput)`
  flex: 1;
  .react-international-phone-input-container {
    display: flex;
    align-items: center;
    border: none; /* Remove internal borders */
    padding: 0;
    height: 40px; /* Set a height that matches the container */
    background: none; /* No background to blend with container */
  }

  .react-international-phone-input {
    border: none;
    outline: none;
    width: 100%;
    padding: 8px;
    font-size: 13px;
  }

  .react-international-phone-country-selector {
    border-right: 1px solid #ddd; /* Divider between flag and input */
    display: flex;
    align-items: center;
    background-color: #f9f9f9; /* Flag section background */
    height: 100%;
    border-radius: 8px 0 0 8px; /* Rounded corners for the flag section */
  }
`;

// New styled components for the redesigned login card
const TabContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
`;

const Tab = styled.button`
  flex: 1;
  padding: 12px;
  background: ${(props) => (props.active ? "#f8f9fa" : "transparent")};
  border: none;
  border-bottom: 3px solid
    ${(props) => (props.active ? "#2563eb" : "transparent")};
  color: ${(props) => (props.active ? "#2563eb" : "#666")};
  font-weight: ${(props) => (props.active ? "600" : "400")};
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #f8f9fa;
    color: #2563eb;
  }
`;

const AuthOption = styled.button`
  width: 100%;
  padding: 12px;
  margin-bottom: 12px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f8f9fa;
    border-color: #2563eb;
  }

  svg {
    margin-right: 8px;
  }
`;

const OrDivider = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  margin: 20px 0;

  hr {
    flex: 1;
    border: none;
    border-top: 1px solid #e0e0e0;
  }

  span {
    padding: 0 10px;
    color: #666;
    font-size: 14px;
  }
`;

const GoogleButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px 0;
`;

const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  text-align: center;
  color: #333;
`;

const Subtitle = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
  text-align: center;
`;

const LoginCard = ({
  setEnablePayButton,
  bypass,
  updateIsUserInfoExists,
  from,
  isEvent,
}) => {
  const [useEmail, setUseEmail] = useState(false);
  const [usePhone, setUsePhone] = useState(false);
  const [isVerified, setVerified] = useState(false);
  const [otpRequested, setOtpRequested] = useState(false);
  const [otp, setOtp] = useState(Array(4).fill(""));
  const [otpValidated, setOtpValidated] = useState(false);
  const [firstName, setfirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [firstNameError, setfirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [countryCode, setCountryCode] = useState("in");
  const [isdCode, setIsdCode] = useState("");
  const [countrycodeISO, setcountrycodeISO] = useState("IN");
  const inputRefs = useRef([]);
  const [alerts, setAlerts] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [resentOTP, setResentOTP] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [profileTypeId, setProfileTypeId] = useState(0);
  const [profileType, setProfileType] = useState("");
  const [profileTypeError, setProfileTypeError] = useState(false);
  const [profileTypes, setProfileTypes] = useState([]);
  const {
    isAuthenticated,
    userName,
    userId,
    bearerToken,
    setIsAuthenticated,
    setUserId,
    checkAuth,
    setUserName,
    isAuthLoading,
  } = useAuth();
  const [isUserInfoExists, setIsUserInfoExists] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const [isHideLoginButton, setIsHideLoginButton] = useState(false);
  const [phoneWithCountryCode, setPhoneWithCountryCode] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [city, setCity] = useState("");
  const [dateOfBirthError, setDateOfBirthError] = useState(false);
  const [cityError, setCityError] = useState(false);

  // New state variables for the redesigned login card
  const [activeTab, setActiveTab] = useState("login");
  const [authMethod, setAuthMethod] = useState("");
  const [isRegisterFlow, setIsRegisterFlow] = useState(false);

  dayjs.extend(utc);
  dayjs.extend(timezone);

  useEffect(() => {
    checkAuth(); // Ensure we fetch actual state from cookie
  }, []);

  useEffect(() => {
    if (!isAuthLoading && isAuthenticated) {
      updateUserDetails();
    }
  }, [isAuthenticated, isAuthLoading]);

  const updateUserDetails = async () => {
    if (isAuthenticated) {
      // Ensure all necessary data is available
      const sessionUseEmail = localStorage.getItem("useEmail");
      const sessionUsePhone = localStorage.getItem("usePhone");
      setUseEmail(sessionUseEmail === "true");
      setUsePhone(sessionUsePhone === "true");
      setUserName(userName);
      const userInfo = await fetchUserDetails();
      setPhoneNumber(userInfo?.phone ? userInfo?.phone : "");
      setEmail(userInfo?.email);
      setfirstName(userInfo?.first_name);
      setLastName(userInfo?.last_name);
      setIsUserInfoExists(
        checkUserInfoExists(
          userInfo?.first_name,
          userInfo?.last_name,
          userInfo?.email,
          userInfo?.phone,
          sessionUseEmail
        )
      );
    }
  };

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0 && resentOTP) {
      setResentOTP(false);
    }
  }, [countdown, resentOTP]);

  useEffect(() => {
    const fetchTypes = async () => {
      var accessToken = bearerToken;
      if (accessToken === "") {
        accessToken = localStorage.getItem("bearerToken");
      }
      await fetchProfileTypes(accessToken, setProfileTypes);
    };
    fetchTypes();
  }, [bearerToken]);

  useEffect(() => {
    const fetchCountry = async () => {
      const countryCode = await getCountryCode();
      setCountryCode(countryCode);
    };
    fetchCountry();
  }, []);

  const handleAddAlert = (title, message, type, autoClose = false) => {
    addAlert(title, message, type, autoClose, setAlerts);
  };

  const handleRemoveAlert = (id) => {
    removeAlert(id, setAlerts);
  };

  const handleSubmitOTP = async () => {
    await handleValidateOTP();
  };

  const handleRequestOTP = () => {
    setEmailError(false);
    setPhoneNumberError(false);

    // For login flow, validate only the selected auth method
    if (activeTab === "login") {
      if (authMethod === "email") {
        if (validateEmail(email, setEmailError, setShowAlert, handleAddAlert)) {
          requestOTP(
            phoneNumber,
            isdCode,
            setOtpRequested,
            setShowAlert,
            handleAddAlert,
            email,
            authMethod,
            activeTab
          );
        }
      } else if (authMethod === "phone") {
        if (
          validatePhoneNumber(
            phoneWithCountryCode,
            setPhoneNumberError,
            setShowAlert,
            handleAddAlert,
            setcountrycodeISO
          )
        ) {
          requestOTP(
            phoneNumber,
            isdCode,
            setOtpRequested,
            setShowAlert,
            handleAddAlert,
            null,
            authMethod,
            activeTab
          );
        }
      }
    }
    // For register flow, validate both email and phone
    else {
      const isPhoneValid = validatePhoneNumber(
        phoneWithCountryCode,
        setPhoneNumberError,
        setShowAlert,
        handleAddAlert,
        setcountrycodeISO
      );

      const isEmailValid = validateEmail(
        email,
        setEmailError,
        setShowAlert,
        handleAddAlert
      );

      if (isPhoneValid && isEmailValid) {
        requestOTP(
          phoneNumber,
          isdCode,
          setOtpRequested,
          setShowAlert,
          handleAddAlert,
          email,
          authMethod,
          activeTab
        );
      }
    }
  };

  const handleResendOTP = () => {
    handleRequestOTP();
    setResentOTP(true);
    setCountdown(30);
  };

  const handlePhoneInputChange = (value, data) => {
    const sanitizedPhoneValue = data.inputValue.replace(/[^0-9]/g, "");
    handlePhoneNumberChange(
      sanitizedPhoneValue,
      data,
      setIsdCode,
      setPhoneNumber,
      setPhoneNumberError,
      setPhoneWithCountryCode
    );
  };

  const handleEmailInputChange = (e) => {
    handleEmailChange(e, setEmail, setEmailError);
  };

  const handlePhoneNumberInputChange = (e) => {
    const value = e.target.value;
    const phoneRegex = /^[0-9]*$/;
    if (value === "" || phoneRegex.test(value)) {
      setPhoneNumber(value);
      setPhoneNumberError(value.trim() === "");
    }
  };

  const handlefirstNameChange = (e) => {
    const value = e.target.value;
    setfirstName(value);

    const regex = /^[A-Za-z\s]*$/;
    if (regex.test(value)) {
      setfirstNameError(value.trim() === "");
    } else {
      setfirstNameError(true);
    }
  };

  const handlelastNameChange = (e) => {
    const value = e.target.value;
    // Allow input updates, even with numbers
    setLastName(value);

    // Validate the input value
    const regex = /^[A-Za-z\s]*$/;
    if (regex.test(value)) {
      setLastNameError(value.trim() === ""); // Check for empty field
    } else {
      setLastNameError(true); // Set error if it contains invalid characters
    }
  };

  const handleOTPInputChange = (e, index) => {
    handleOTPChange(e, index, otp, setOtp, inputRefs);
  };

  const handleOTPKeyDown = (e, index) => {
    handleKeyDown(e, index, otp, inputRefs);
  };

  const handleProfileTypeChange = (e) => {
    const selectedId = e.target.value;
    const selectedType = profileTypes.find(
      (type) => type.id.toString() === selectedId
    );
    if (selectedType) {
      setProfileType(selectedType.title);
      setProfileTypeId(selectedType.id);
    } else {
      setProfileType("");
    }
    setProfileTypeError(false);
  };

  const handleValidateOTP = async () => {
    setUseEmail(false);
    setUsePhone(true);
    await validateOTP(
      otp,
      isdCode,
      phoneNumber,
      authMethod,
      activeTab,
      email,
      setOtpValidated,
      setVerified,
      setUserId,
      setShowAlert,
      handleAddAlert,
      setfirstName,
      setLastName,
      setUserName,
      setEmail,
      setPhoneNumber,
      setIsAuthenticated,
      setIsUserInfoExists,
      setEnablePayButton,
      updateIsUserInfoExists
    );
  };

  const handleGoogleLoginSuccess = (credentialResponse) => {
    setUseEmail(true);
    setUsePhone(false);
    validateGoogleLoginWithToken(
      credentialResponse.credential,
      setOtpValidated,
      setVerified,
      setUserId,
      setShowAlert,
      handleAddAlert,
      setEmail,
      setPhoneNumber,
      setfirstName,
      setLastName,
      setUserName,
      setIsAuthenticated,
      setIsUserInfoExists,
      true,
      setEnablePayButton,
      updateIsUserInfoExists
    );
  };

  const handleDateOfBirthChange = (newDate) => {
    if (newDate) {
      // Convert to IST (Indian Standard Time)
      const dateInIST = dayjs(newDate).tz("Asia/Kolkata").format("YYYY-MM-DD");

      setDateOfBirth(dateInIST); // Set the formatted date (without time) in state
    } else {
      setDateOfBirth(null); // Handle no date selected
    }
    setDateOfBirth(newDate);
    setDateOfBirthError(!newDate);
  };

  const handleCityChange = (e) => {
    setCity(e.target.value);
    setCityError(!e.target.value);
  };

  // New handlers for the redesigned login card
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setIsRegisterFlow(tab === "register");
    // Reset auth method when switching tabs
    setAuthMethod("");
    // Reset errors
    setEmailError(false);
    setPhoneNumberError(false);
  };

  const handleAuthMethodSelect = (method) => {
    setAuthMethod(method);
    if (method === "phone") {
      setUseEmail(false);
      setUsePhone(true);
    } else if (method === "email") {
      setUseEmail(true);
      setUsePhone(false);
    }
  };

  const handleLoginRequest = () => {
    if (isRegisterFlow) {
      // For register flow, validate both email and phone
      const isPhoneValid = validatePhoneNumber(
        phoneWithCountryCode,
        setPhoneNumberError,
        setShowAlert,
        handleAddAlert,
        setcountrycodeISO
      );

      const isEmailValid = validateEmail(
        email,
        setEmailError,
        setShowAlert,
        handleAddAlert
      );

      if (isPhoneValid && isEmailValid) {
        requestOTP(
          phoneNumber,
          isdCode,
          setOtpRequested,
          setShowAlert,
          handleAddAlert,
          email,
          authMethod,
          activeTab
        );
      }
    } else {
      // For login flow, use the selected auth method
      handleRequestOTP();
    }
  };

  // const handleLoginError = () => {
  //   console.error("Google Login Failed");
  // };

  // const googleLogin = useGoogleLogin({
  //   onSuccess: handleGoogleLoginSuccess,
  //   onError: handleLoginError,
  // });

  const handleGoogleLoginError = () => {
    setShowAlert(true);
    handleAddAlert(
      "Login Error",
      "Failed to login with google. Please try again",
      "error",
      true
    );
  };

  const validateForm = () => {
    let valid = true; // Initialize valid flag

    // Regex patterns
    const nameRegex = /^[A-Za-z\s]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!firstName || !nameRegex.test(firstName)) {
      setfirstNameError(true);
      valid = false;
    } else {
      setfirstNameError(false);
    }

    if (!lastName || !nameRegex.test(lastName)) {
      setLastNameError(true);
      valid = false;
    } else {
      setLastNameError(false);
    }

    if (useEmail) {
      let isPhoneValid = validatePhoneNumber(
        phoneWithCountryCode,
        setPhoneNumberError,
        setShowAlert,
        handleAddAlert,
        setcountrycodeISO
      );
      if (!isPhoneValid) {
        setPhoneNumberError(true);
        valid = false;
      } else {
        setPhoneNumberError(false);
      }
    } else {
      let isPhoneValid = validatePhoneNumber(
        phoneWithCountryCode,
        setPhoneNumberError,
        setShowAlert,
        handleAddAlert,
        setcountrycodeISO
      );
      if (!isPhoneValid) {
        setPhoneNumberError(true);
        valid = false;
      } else {
        setPhoneNumberError(false);
      }

      if (!email || !emailRegex.test(email)) {
        setEmailError(true);
        valid = false;
      } else {
        setEmailError(false);
      }
    }

    if (!profileType) {
      setProfileTypeError(true);
      valid = false;
    } else {
      setProfileTypeError(false);
    }

    if (!dateOfBirth) {
      setDateOfBirthError(true);
      valid = false;
    } else {
      setDateOfBirthError(false);
    }

    // Validate City (Check if city is non-empty)
    const country_code = sessionStorage.getItem("country_code");
    if (country_code === "in" || countryCode === "IN") {
      if (!city || city.trim() === "") {
        setCityError(true);
        valid = false;
      } else {
        setCityError(false);
      }
    }

    return valid;
  };

  const fetchWorkshopDetailsAndPay = async () => {
    let valid = true;
    if (!isUserInfoExists) {
      valid = validateForm();
    }

    if (valid) {
      setIsLoading(true);
      try {
        let userDetailsUpdated;
        if (!isUserInfoExists) {
          const result = await sumbitUserDetails();
          userDetailsUpdated = result.success;

          if (result.alertShown) {
            return;
          }
        }

        if (userDetailsUpdated || isUserInfoExists) {
          if (bypass) {
            setIsUserInfoExists(true);
            updateIsUserInfoExists(true);
            setEnablePayButton(true);
            setIsHideLoginButton(true);
            setIsLoading(false);
          } else {
            if (from === "/") {
              await new Promise((resolve) => setTimeout(resolve, 500));
              navigate("/");
              window.location.reload();
            } else {
              navigate(from, { replace: true });
            }
          }
        } else {
          setShowAlert(true);
          handleAddAlert(
            "Input Error",
            "There was an issue while submitting the form",
            "error",
            true
          );
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error in flow:", error);
        setIsLoading(false);
      }
    } else {
      setShowAlert(true);
      handleAddAlert(
        "Input Error",
        "Please fill in all mandatory fields before proceeding",
        "error",
        true
      );
      setIsLoading(false);
    }
  };

  const sumbitUserDetails = async () => {
    let registerAsId, title;
    switch (profileType.toLowerCase()) {
      case "mom":
        title = "Mrs";
        break;
      case "dad":
        title = "Mr";
        break;
      case "grand pa":
        title = "Mr";
        break;
      case "grand ma":
        title = "Mrs";
        break;
      default:
        title = "Mr/Mrs";
    }

    const formattedDateOfBirth = dayjs(dateOfBirth).format("YYYY-MM-DD");
    const country_code = sessionStorage.getItem("country_code");
    const userDetails = {
      id: userId,
      phone: phoneNumber,
      first_name: firstName,
      last_name: lastName,
      email: email,
      register_as_id: profileTypeId,
      title: title,
      isd_code: isdCode,
      date_of_birth: formattedDateOfBirth,
      ...(country_code === "in" && { city: city }),
    };
    try {
      const res = await open_api_with_cookies.patch(
        `/profiles/update_profile/`,
        userDetails
      );

      //console.log(res);
      if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
        localStorage.setItem("userName", firstName + " " + lastName);
        setUserName(firstName + " " + lastName);
        return { success: true, alertShown: false };
      } else if (res?.status === 400) {
        if (res?.data?.email) {
          setShowAlert(true);
          handleAddAlert("Input Error", res?.data?.email, "error", true);
          setIsLoading(false);
          return { success: false, alertShown: true };
        } else if (res?.data?.phone) {
          setShowAlert(true);
          handleAddAlert("Input Error", res?.data?.phone, "error", true);
          setIsLoading(false);
          return { success: false, alertShown: true };
        } else {
          setShowAlert(true);
          handleAddAlert("Input Error", res?.data, "error", true);
          setIsLoading(false);
          return { success: false, alertShown: true };
        }
      }
    } catch (err) {
      console.error("Error in sumbitUserDetails:", err);
      return { success: false, alertShown: false };
    }
    return { success: false, alertShown: false };
  };

  return (
    <>
      {isLoading && <LoadingOverlay message={message} />}
      {!isAuthenticated ? (
        <Card isEvent={isEvent}>
          {otpValidated ? (
            <>
              {!isUserInfoExists ? (
                <UserProfileForm
                  useEmail={useEmail}
                  email={email}
                  isdCode={isdCode}
                  countrycodeISO={countrycodeISO}
                  CustomPhoneInput={CustomPhoneInput}
                  phoneNumber={phoneNumber}
                  usePhone={usePhone}
                  firstName={firstName}
                  lastName={lastName}
                  dateOfBirth={dateOfBirth}
                  city={city}
                  profileType={profileType}
                  profileTypes={profileTypes}
                  firstNameError={firstNameError}
                  lastNameError={lastNameError}
                  phoneNumberError={phoneNumberError}
                  emailError={emailError}
                  dateOfBirthError={dateOfBirthError}
                  cityError={cityError}
                  profileTypeError={profileTypeError}
                  handlefirstNameChange={handlefirstNameChange}
                  handlelastNameChange={handlelastNameChange}
                  handlePhoneNumberInputChange={handlePhoneInputChange}
                  handleEmailInputChange={handleEmailInputChange}
                  handleDateOfBirthChange={handleDateOfBirthChange}
                  handleCityChange={handleCityChange}
                  handleProfileTypeChange={handleProfileTypeChange}
                />
              ) : (
                <>
                  <SuccessMessage>
                    <CheckCircleIcon color="success" />
                    <h3>You are logged in as {userName}</h3>
                  </SuccessMessage>
                </>
              )}
            </>
          ) : otpRequested ? (
            <>
              <CardTitle>OTP Verification</CardTitle>
              <h3>
                A 4-digit code has been sent to{" "}
                {useEmail ? (
                  <span style={{ fontWeight: "bold", color: "#2563eb" }}>
                    {email} and to your registered phone number
                  </span>
                ) : (
                  <span style={{ fontWeight: "bold", color: "#2563eb" }}>
                    +{isdCode} {phoneNumber} and to your registered email
                  </span>
                )}
              </h3>
              <OtpInputContainer>
                {Array.from({ length: 4 }).map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={otp[index]}
                    onChange={(e) => handleOTPInputChange(e, index)}
                    onKeyDown={(e) => handleOTPKeyDown(e, index)}
                    ref={(el) => (inputRefs.current[index] = el)}
                  />
                ))}
              </OtpInputContainer>
              <Button onClick={handleSubmitOTP}>Verify OTP</Button>
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                {resentOTP ? (
                  <div>
                    <p>Resend OTP in {countdown} seconds</p>
                  </div>
                ) : (
                  <div>
                    <ResendOtpLink onClick={handleResendOTP}>
                      Resend OTP
                    </ResendOtpLink>
                    <p style={{ marginTop: "8px", textAlign: "center" }}>
                      Didn't receive a code? Click on Resend to receive OTP
                    </p>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <TabContainer>
                <Tab
                  active={activeTab === "login"}
                  onClick={() => handleTabChange("login")}
                >
                  Login
                </Tab>
                <Tab
                  active={activeTab === "register"}
                  onClick={() => handleTabChange("register")}
                >
                  Register
                </Tab>
              </TabContainer>

              {activeTab === "login" ? (
                // Login Tab Content
                <>
                  <CardTitle>Welcome Back</CardTitle>

                  {!authMethod ? (
                    // Authentication method selection
                    <>
                      <AuthOption
                        onClick={() => handleAuthMethodSelect("phone")}
                      >
                        <PhoneIcon
                          style={{ color: "#2563eb", marginRight: "8px" }}
                        />
                        Login with Phone Number
                      </AuthOption>
                      <AuthOption
                        onClick={() => handleAuthMethodSelect("email")}
                      >
                        <EmailIcon
                          style={{ color: "#2563eb", marginRight: "8px" }}
                        />
                        Login with Email
                      </AuthOption>

                      <OrDivider>
                        <hr />
                        <span>OR</span>
                        <hr />
                      </OrDivider>

                      <GoogleButtonWrapper>
                        <GoogleLogin
                          onSuccess={handleGoogleLoginSuccess}
                          onError={handleGoogleLoginError}
                        />
                      </GoogleButtonWrapper>
                    </>
                  ) : (
                    // Login form based on selected method
                    <>
                      <CardTitle>
                        Login with{" "}
                        {authMethod === "phone" ? "Phone Number" : "Email"}
                      </CardTitle>

                      {authMethod === "phone" && (
                        <>
                          <OtpContainer
                            style={{
                              borderColor: phoneNumberError ? "red" : "#ccc",
                            }}
                          >
                            <CustomPhoneInput
                              defaultCountry={countryCode}
                              value={phoneNumber}
                              disableDialCodeAndPrefix={true}
                              onChange={handlePhoneInputChange}
                              placeholder="Enter your phone number"
                            />
                          </OtpContainer>
                          {phoneNumberError && (
                            <ErrorText>
                              Please enter a valid phone number
                            </ErrorText>
                          )}
                        </>
                      )}

                      {authMethod === "email" && (
                        <>
                          <InputField
                            name="email"
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={handleEmailInputChange}
                            style={{
                              borderColor: emailError ? "red" : "#ccc",
                            }}
                          />
                          {emailError && (
                            <ErrorText>Please enter a valid email</ErrorText>
                          )}
                        </>
                      )}

                      <Button onClick={handleLoginRequest}>Request OTP</Button>
                      <AuthOption
                        onClick={() => setAuthMethod("")}
                        style={{ marginTop: "10px", background: "#f5f5f5" }}
                      >
                        <ArrowBackIcon style={{ marginRight: "8px" }} />
                        Back to Options
                      </AuthOption>
                    </>
                  )}
                </>
              ) : (
                // Register Tab Content
                <>
                  <CardTitle>Create New Account</CardTitle>
                  <Subtitle>Register with your phone and email</Subtitle>

                  <OtpContainer
                    style={{
                      borderColor: phoneNumberError ? "red" : "#ccc",
                      marginBottom: "16px",
                    }}
                  >
                    <CustomPhoneInput
                      defaultCountry={countryCode}
                      value={phoneNumber}
                      disableDialCodeAndPrefix={true}
                      onChange={handlePhoneInputChange}
                      placeholder="Enter your phone number"
                    />
                  </OtpContainer>
                  {phoneNumberError && (
                    <ErrorText>Please enter a valid phone number</ErrorText>
                  )}

                  <InputField
                    name="email"
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={handleEmailInputChange}
                    style={{
                      borderColor: emailError ? "red" : "#ccc",
                    }}
                  />
                  {emailError && (
                    <ErrorText>Please enter a valid email</ErrorText>
                  )}

                  <Button onClick={handleLoginRequest}>Continue</Button>

                  <OrDivider>
                    <hr />
                    <span>OR</span>
                    <hr />
                  </OrDivider>

                  <GoogleButtonWrapper>
                    <GoogleLogin
                      onSuccess={handleGoogleLoginSuccess}
                      onError={handleGoogleLoginError}
                    />
                  </GoogleButtonWrapper>
                </>
              )}
            </>
          )}
          <h5 style={{ fontWeight: 400 }}>
            By logging in, you agree to our{" "}
            <a
              href="https://www.myburgo.com/terms-and-condition"
              target="_blank"
              style={{ color: "#2563eb" }}
            >
              Terms and Conditions
            </a>{" "}
            and{" "}
            <a
              href="https://www.myburgo.com/privacy-policy"
              target="_blank"
              style={{ color: "#2563eb" }}
            >
              Privacy Policy
            </a>
            .
          </h5>
        </Card>
      ) : (
        <Card isEvent={isEvent}>
          {!isUserInfoExists ? (
            <UserProfileForm
              useEmail={useEmail}
              email={email}
              isdCode={isdCode}
              countrycodeISO={countrycodeISO}
              CustomPhoneInput={CustomPhoneInput}
              phoneNumber={phoneNumber}
              usePhone={usePhone}
              firstName={firstName}
              lastName={lastName}
              dateOfBirth={dateOfBirth}
              city={city}
              profileType={profileType}
              profileTypes={profileTypes}
              firstNameError={firstNameError}
              lastNameError={lastNameError}
              phoneNumberError={phoneNumberError}
              emailError={emailError}
              dateOfBirthError={dateOfBirthError}
              cityError={cityError}
              profileTypeError={profileTypeError}
              handlefirstNameChange={handlefirstNameChange}
              handlelastNameChange={handlelastNameChange}
              handlePhoneNumberInputChange={handlePhoneInputChange}
              handleEmailInputChange={handleEmailInputChange}
              handleDateOfBirthChange={handleDateOfBirthChange}
              handleCityChange={handleCityChange}
              handleProfileTypeChange={handleProfileTypeChange}
            />
          ) : (
            <SuccessMessage>
              <CheckCircleIcon color="success" />
              <h3>You are logged in as {userName}</h3>
            </SuccessMessage>
          )}

          {bypass ? (
            <>
              {(isAuthenticated && isUserInfoExists) || isHideLoginButton ? (
                <></>
              ) : (
                <LoginButton
                  className="payButton"
                  onClick={fetchWorkshopDetailsAndPay}
                  bypass={bypass}
                >
                  Login
                </LoginButton>
              )}
            </>
          ) : (
            !isEvent && (
              <>
                <LoginButton
                  className="payButton"
                  onClick={fetchWorkshopDetailsAndPay}
                  bypass={bypass}
                >
                  {isUserInfoExists ? "Continue" : "Login"}
                </LoginButton>
              </>
            )
          )}
          <h5 style={{ fontWeight: 400 }}>
            By logging in, you agree to our{" "}
            <a
              href="https://www.myburgo.com/terms-and-condition"
              target="_blank"
              style={{ color: "#2563eb" }}
            >
              Terms and Conditions
            </a>{" "}
            and{" "}
            <a
              href="https://www.myburgo.com/privacy-policy"
              target="_blank"
              style={{ color: "#2563eb" }}
            >
              Privacy Policy
            </a>
            .
          </h5>
        </Card>
      )}
      {showAlert &&
        alerts.map((alert) => (
          <CustomAlert
            key={alert.id}
            title={alert.title}
            message={alert.message}
            onClose={() => handleRemoveAlert(alert.id)}
            autoClose={alert.autoClose}
            type={alert.type}
          />
        ))}
    </>
  );
};

export default LoginCard;
